<template>
    <div class="send_delivery">
        <div class="send_delivery__header">
            <h4>{{__t('ORDER_DELIVERY')}}</h4>

            <div v-if="!canCall" class="send_delivery__warning">
                {{__t('ORDER_WITHOUT_DELIVERY')}}
            </div>
        </div>

        <div v-if="attachedDeliveries.length" class="send_delivery__block">
            <label class="send_delivery__label">
                {{__t('DELIVERY_PROVIDER')}}
            </label>

            <div class="delivery_tabs">
                <button
                    v-for="delivery in attachedDeliveries"
                    :key="delivery.location_id"
                    type="button"
                    class="delivery_tab"
                    :class="{ active: selected_delivery_location_id === delivery.location_id }"
                    @click="selectDelivery(delivery)"
                >
                    <span
                        v-if="delivery.provider && delivery.provider.icon"
                        class="delivery_tab__icon"
                        v-html="delivery.provider.icon"
                    ></span>

                    <span class="delivery_tab__text">
                        {{ getProviderTitle(delivery) }}
                    </span>

                    <small>#{{ delivery.location_id }}</small>
                </button>
            </div>
        </div>

        <div v-else class="send_delivery__empty">
            Немає підключених служб доставки
        </div>

        <div class="send_delivery__form">

            <div class="timeline">


            </div>


            <div class="send_delivery__asap_box">
                <div class="send_delivery__field_label">ASAP</div>
                <yes_no key="ASAP" title="" v-model="form.asap"></yes_no>
            </div>

            <div class="send_delivery__time_line">
                <div class="send_delivery__field send_delivery__time_field">
                    <label>{{__t('DELIVERY_TIME')}}</label>
                    <input
                        type="text"
                        v-model="form.est_time"
                        :disabled="form.asap"
                        placeholder="2026-04-28 11:21:00"
                    >
                </div>
            </div>

            <div class="send_delivery__section">
                <h5>Клієнт</h5>
                <div class="send_delivery__grid">
                    <div class="send_delivery__field">
                        <label>{{__t('CUSTOMER_NAME')}}</label>
                        <input type="text" v-model="form.customer.name">
                    </div>

                    <div class="send_delivery__field">
                        <label>{{__t('CUSTOMER_PHONE')}}</label>
                        <input type="text" v-model="form.customer.phone">
                    </div>
                </div>
            </div>

            <div class="send_delivery__section mt-5">
                <h5>{{__t('DELIVERY_ADDRESS')}}</h5>




                <div class="send_delivery__address_mode mb-5">

                    <yes_no
                        key="ADDRESS_MODE"
                        v-model="address_mode"
                        :radio_options="base_url_options"
                        title="ADDRESS_MODE">

                    </yes_no>

                    <!--
                    <button
                        type="button"
                        class="address_mode_btn"
                        :class="{ active: address_mode === 'full' }"
                        @click="address_mode = 'full'"
                    >
                        {{__t('FULL_ADDRESS')}}
                    </button>

                    <button
                        type="button"
                        class="address_mode_btn"
                        :class="{ active: address_mode === 'parts' }"
                        @click="address_mode = 'parts'"
                    >
                        {{__t('ADDRESS_BY_FIELDS') || 'По полях'}}
                    </button>
                    -->

                </div>

                <div v-if="address_mode === 'full'" class="send_delivery__field">
                    <label>{{__t('FULL_ADDRESS')}}</label>
                    <input
                        type="text"
                        v-model="form.delivery_point.address"
                        placeholder="вулиця Райдужна,21А"
                    >
                </div>

                <div v-else class="send_delivery__grid">
                    <div class="send_delivery__field">
                        <label>{{__t('STREET') || 'Вулиця'}}</label>
                        <input
                            type="text"
                            v-model="form.delivery_point.street"
                            placeholder="вулиця Райдужна"
                        >
                    </div>

                    <div class="send_delivery__field">
                        <label>{{__t('HOUSE') || 'Будинок'}}</label>
                        <input
                            type="text"
                            v-model="form.delivery_point.house"
                            placeholder="21А"
                        >
                    </div>
                </div>

                <div class="send_delivery__field mt-5">
                    <label>{{__t('DELIVERY_COMMENT')}}</label>
                    <textarea
                        v-model="form.delivery_point.comment"
                        rows="3"
                        placeholder="Підʼїзд, поверх, домофон, уточнення"
                    ></textarea>
                </div>
            </div>

            <div v-if="error" class="send_delivery__error">
                {{ error }}
            </div>

            <div v-if="success" class="send_delivery__success">
                {{ success }}
            </div>

            <div class="send_delivery__actions">
                <button
                    type="button"
                    class="send_delivery__btn"
                    :disabled="sending || !canSubmit"
                    @click="sendDelivery"
                >
                    {{ sending ? 'Відправляю...' : 'Відправити доставку' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import yes_no from "../../../sys/radio/yes_no.vue";

export default {
    name: "order_delivery",
    components: {yes_no},

    props: {
        order: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            address_mode: 'full',
            selected_delivery_location_id: 0,
            selected_delivery: null,

            sending: false,
            error: '',
            success: '',
            base_url_options : [
                {text: 'LABEL',  value: 'full'},
                {text: 'PARTS', value: 'parts'},
            ],
            form: {
                asap: true,
                est_time: '',
                delivery_location_id: 0,

                delivery_point: {
                    address: '',
                    street: '',
                    house: '',
                    comment: '',
                    lat: null,
                    lng: null
                },

                customer: {
                    name: '',
                    phone: ''
                }
            }
        };
    },

    computed: {
        deliveryProvider() {
            return this.order && this.order.delivery_provider
                ? this.order.delivery_provider
                : {};
        },

        attachedDeliveries() {
            return this.deliveryProvider.attached_deliveries || [];
        },

        defaultLocationId() {
            if (
                this.deliveryProvider.default_location &&
                this.deliveryProvider.default_location.id
            ) {
                return this.deliveryProvider.default_location.id;
            }

            return 0;
        },

        canCall() {
            return !!this.deliveryProvider.can_call;
        },

        canSubmit() {
            return this.canCall &&
                this.selected_delivery_location_id > 0 &&
                this.form.customer.name &&
                this.form.customer.phone &&
                this.form.delivery_point.address;
        }
    },

    watch: {
        order: {
            deep: true,
            immediate: true,
            handler() {
                this.initForm();
            }
        }
    },

    methods: {
        initForm() {
            this.error = '';
            this.success = '';

            this.fillDefaultForm();
            this.selectDefaultDelivery();
        },

        selectDefaultDelivery() {
            if (!this.attachedDeliveries.length) {
                this.selected_delivery = null;
                this.selected_delivery_location_id = 0;
                this.form.delivery_location_id = 0;
                return;
            }

            var found = null;

            for (var i = 0; i < this.attachedDeliveries.length; i++) {
                if (this.attachedDeliveries[i].location_id === this.defaultLocationId) {
                    found = this.attachedDeliveries[i];
                    break;
                }
            }

            if (!found) {
                found = this.attachedDeliveries[0];
            }

            this.selectDelivery(found);
        },

        selectDelivery(delivery) {
            this.selected_delivery = delivery;
            this.selected_delivery_location_id = delivery.location_id;
            this.form.delivery_location_id = delivery.location_id;
        },

        fillDefaultForm() {
            var delivery = this.order.delivery || {};
            var customer = this.order.customer || {};
            var time = this.order.time || {};
            var fullInp = this.order.full_inp || {};
            var addressFields = fullInp.address_fields || {};
            var deliveryCoords = fullInp.delivery_coords || {};
            var coordinates = delivery.coordinates || {};

            var street = delivery.street || addressFields.street || '';
            var house = delivery.house || addressFields.house || '';
            var address = delivery.full_label || delivery.label || '';

            if (!address && (street || house)) {
                address = street + (house ? ',' + house : '');
            }

            this.form.asap = false;
            this.form.est_time = time.est_time || '';

            this.form.customer.name = customer.name || this.getNested(fullInp, 'customer_fields.name', '');
            this.form.customer.phone = this.normalizePhone(
                customer.phone || this.getNested(fullInp, 'customer_fields.phone', '')
            );

            this.form.delivery_point.address = address;
            this.form.delivery_point.street = street;
            this.form.delivery_point.house = house;
            this.form.delivery_point.comment = delivery.comment || this.order.advanced_comment || '';

            // Координаты не показываем в форме, но если они есть в заказе — отправляем скрыто.
            this.form.delivery_point.lat = coordinates.lat || deliveryCoords.lat || null;
            this.form.delivery_point.lng = coordinates.long || coordinates.lng || deliveryCoords.lng || null;
        },

        getProviderTitle(delivery) {
            if (!delivery || !delivery.provider) {
                return 'Delivery';
            }

            return delivery.provider.type || ('Provider #' + delivery.provider.id);
        },

        normalizePhone(phone) {
            if (!phone) {
                return '';
            }

            return String(phone).replace(/^\+/, '');
        },

        getNested(obj, path, def) {
            var parts = path.split('.');
            var cur = obj;

            for (var i = 0; i < parts.length; i++) {
                if (!cur || typeof cur !== 'object' || typeof cur[parts[i]] === 'undefined') {
                    return def;
                }

                cur = cur[parts[i]];
            }

            return cur;
        },

        buildPayload() {
            var payload = {
                asap: !!this.form.asap,
                est_time: this.form.asap ? null : this.form.est_time,
                delivery_location_id: this.form.delivery_location_id,

                delivery_point: {
                    address: this.form.delivery_point.address,
                    street: this.form.delivery_point.street,
                    house: this.form.delivery_point.house,
                    comment: this.form.delivery_point.comment
                },

                customer: {
                    name: this.form.customer.name,
                    phone: this.normalizePhone(this.form.customer.phone)
                }
            };

            if (this.form.delivery_point.lat && this.form.delivery_point.lng) {
                payload.delivery_point.lat = Number(this.form.delivery_point.lat);
                payload.delivery_point.lng = Number(this.form.delivery_point.lng);
            }

            return payload;
        },

        sendDelivery() {
            var self = this;

            if (!this.canSubmit) {
                this.error = 'EMPTY_FIELDS';
                return;
            }

            this.sending = true;
            this.error = '';
            this.success = '';


            var url = 'order/' + this.order.id + '/manual_send';

            delivery_api.put(url, this.buildPayload())
                .then(function (response) {
                    self.success = self.__t('SUCCESS_SEND');

                    self.$emit('sent', {
                        response: response.data,
                        payload: self.buildPayload()
                    });

                    EventBus.$emit('reload_order_inside');
                })
                .catch(function (e) {
                    var message = self.__t('ERR_SEND');

                    if (e.response && e.response.data && e.response.data.message) {
                        message = e.response.data.message;
                    }

                    self.error = message;
                    self.$emit('error', e);
                })
                .finally(function () {
                    self.sending = false;
                });
        }
    }
}
</script>

<style scoped>
.send_delivery {
    border: 1px solid #dfe3ea;
    border-radius: 8px;
    padding: 16px;
    background: #fff;
    font-size: 13px;
    color: #2f3542;
}

.send_delivery__header {
    margin-bottom: 14px;
}

.send_delivery__header h4 {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.2;
}

.send_delivery__warning,
.send_delivery__empty {
    margin-top: 10px;
    padding: 10px 12px;
    border-radius: 6px;
    background: #fff7ed;
    color: #9a3412;
    font-size: 13px;
}

.send_delivery__block {
    margin-bottom: 16px;
}

.send_delivery__label {
    display: block;
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 700;
    color: #374151;
    text-transform: uppercase;
}

.delivery_tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.delivery_tab {
    height: 36px;
    min-width: 110px;
    padding: 0 10px;
    border: 1px solid #ccd5e1;
    border-radius: 5px;
    background: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
    line-height: 1;
}

.delivery_tab.active {
    border-color: #2563eb;
    background: #eef4ff;
}

.delivery_tab__icon {
    display: none;
}

.delivery_tab__text {
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
}

.delivery_tab small {
    font-size: 11px;
    color: #4b5563;
    font-weight: 400;
}

.send_delivery__form {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.send_delivery__time_line {
    display: block;
    grid-template-columns: 95px 1fr;
    column-gap: 12px;
    align-items: end;
    padding-bottom: 14px;
    border-bottom: 1px solid #edf0f5;
}

.send_delivery__asap_box {
    overflow: hidden;
}

.send_delivery__asap_box .send_delivery__field_label {
    margin-bottom: 6px;
}

.send_delivery__field_label,
.send_delivery__field label {
    display: block;
    font-size: 12px;
    font-weight: 700;
    color: #4b5563;
    line-height: 1.2;
}

.send_delivery__field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}

.send_delivery__time_field {
    width: 100%;
    min-width: 0;
}

.send_delivery__section {
    padding-top: 0;
    border-top: none;
}

.send_delivery__section h5 {
    margin: 0 0 10px;
    font-size: 14px;
    font-weight: 700;
    color: #2f3542;
}

.send_delivery__grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 12px;
}

.send_delivery__field input,
.send_delivery__field textarea {
    width: 100%;
    min-height: 36px;
    border: 1px solid #cfd6e0;
    border-radius: 6px;
    padding: 8px 10px;
    font-size: 14px;
    outline: none;
    box-sizing: border-box;
    background: #fff;
}

.send_delivery__field textarea {
    min-height: 72px;
    resize: vertical;
}

.send_delivery__field input:focus,
.send_delivery__field textarea:focus {
    border-color: #2563eb;
}

.send_delivery__field input:disabled {
    background: #f5f6f8;
    color: #6b7280;
}

.send_delivery__error {
    padding: 10px 12px;
    border-radius: 6px;
    background: #fff1f2;
    color: #b91c1c;
    font-size: 13px;
}

.send_delivery__success {
    padding: 10px 12px;
    border-radius: 6px;
    background: #ecfdf5;
    color: #047857;
    font-size: 13px;
}

.send_delivery__actions {
    display: flex;
    justify-content: flex-end;
}

.send_delivery__btn {
    border: none;
    border-radius: 7px;
    background: #2563eb;
    color: #fff;
    padding: 10px 16px;
    font-weight: 700;
    cursor: pointer;
}

.send_delivery__btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

@media (max-width: 700px) {
    .send_delivery__time_line {
        grid-template-columns: 1fr;
        row-gap: 10px;
    }

    .send_delivery__asap_box {
        width: 100%;
    }

    .send_delivery__grid {
        grid-template-columns: 1fr;
    }
}
</style>
